module.exports = __webpack_public_path__ + "img/service-nongmaodianshang2.39ea1f01.svg";